import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { renderChildren, text } from "../helpers";
import InlineIcon from "../InlineIcon.svelte";

var root = $.from_html(`<div class="slex-section-eyebrow"> </div>`);
var root_1 = $.from_html(`<span> </span>`);
var root_2 = $.from_html(`<h2 class="slex-section-title"><!><!></h2>`);
var root_3 = $.from_html(`<p class="slex-section-subtitle"> </p>`);
var root_4 = $.from_html(`<a class="slex-section-action"> </a>`);
var root_5 = $.from_html(`<header class="slex-section-header"><!> <!> <!> <!></header>`);
var root_6 = $.from_html(`<section class="slex-section"><!> <div class="slex-section-body"></div></section>`);

export default function Section($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	var section = root_6();
	var node = $.child(section);

	{
		var consequent_6 = ($$anchor) => {
			var header = root_5();
			var node_1 = $.child(header);

			{
				var consequent = ($$anchor) => {
					var div = root();
					var text_1 = $.child(div, true);

					$.reset(div);
					$.template_effect(($0) => $.set_text(text_1, $0), [() => text($.get(p).eyebrow)]);
					$.append($$anchor, div);
				};

				$.if(node_1, ($$render) => {
					if ($.get(p).eyebrow) $$render(consequent);
				});
			}

			var node_2 = $.sibling(node_1, 2);

			{
				var consequent_3 = ($$anchor) => {
					var h2 = root_2();
					var node_3 = $.child(h2);

					{
						var consequent_1 = ($$anchor) => {
							InlineIcon($$anchor, {
								get name() {
									return $.get(p).icon;
								},
								className: 'slex-section-icon'
							});
						};

						$.if(node_3, ($$render) => {
							if ($.get(p).icon) $$render(consequent_1);
						});
					}

					var node_4 = $.sibling(node_3);

					{
						var consequent_2 = ($$anchor) => {
							var span = root_1();
							var text_2 = $.child(span, true);

							$.reset(span);
							$.template_effect(($0) => $.set_text(text_2, $0), [() => text($.get(p).title)]);
							$.append($$anchor, span);
						};

						$.if(node_4, ($$render) => {
							if ($.get(p).title) $$render(consequent_2);
						});
					}

					$.reset(h2);
					$.append($$anchor, h2);
				};

				$.if(node_2, ($$render) => {
					if ($.get(p).title || $.get(p).icon) $$render(consequent_3);
				});
			}

			var node_5 = $.sibling(node_2, 2);

			{
				var consequent_4 = ($$anchor) => {
					var p_1 = root_3();
					var text_3 = $.child(p_1, true);

					$.reset(p_1);
					$.template_effect(($0) => $.set_text(text_3, $0), [() => text($.get(p).subtitle)]);
					$.append($$anchor, p_1);
				};

				$.if(node_5, ($$render) => {
					if ($.get(p).subtitle) $$render(consequent_4);
				});
			}

			var node_6 = $.sibling(node_5, 2);

			{
				var consequent_5 = ($$anchor) => {
					var a = root_4();
					var text_4 = $.child(a, true);

					$.reset(a);

					$.template_effect(
						($0, $1) => {
							$.set_attribute(a, 'href', $0);
							$.set_text(text_4, $1);
						},
						[
							() => text($.get(p).actionHref, "#"),
							() => text($.get(p).actionLabel)
						]
					);

					$.append($$anchor, a);
				};

				$.if(node_6, ($$render) => {
					if ($.get(p).actionLabel) $$render(consequent_5);
				});
			}

			$.reset(header);
			$.append($$anchor, header);
		};

		$.if(node, ($$render) => {
			if ($.get(p).title || $.get(p).subtitle || $.get(p).eyebrow) $$render(consequent_6);
		});
	}

	var div_1 = $.sibling(node, 2);

	$.action(div_1, ($$node, $$action_arg) => renderChildren?.($$node, $$action_arg), () => $$props.ctx);
	$.reset(section);

	$.template_effect(($0) => $.set_attribute(section, 'id', $0), [
		() => text($.get(p).id ?? $$props.componentName) || undefined
	]);

	$.append($$anchor, section);
	$.pop();
}